/*function changeLocation(){
    jQuery('#main-nav a').on('click', function(){
        var hrefTag = $(this).attr('href');
        window.location.href = hrefTag;
    });
}changeLocation();*/

var sideProd = jQuery('.side-product');
jQuery(sideProd).mouseenter(function(){
    var dataNum = jQuery(this).attr('data-number');
    var prodDot = jQuery('.hotspot-'+dataNum);

    jQuery(prodDot).addClass('prodDotEffect');
});

jQuery(sideProd).mouseleave(function(){
    var dataNum = jQuery(this).attr('data-number');
    var prodDot = jQuery('.hotspot-'+dataNum);
    
    jQuery(prodDot).removeClass('prodDotEffect');
});
function myFunction() {
  var dots = document.getElementById("dots");
  var moreText = document.getElementById("more");
  var btnText = document.getElementById("myBtn");

  if (dots.style.display === "none") {
    dots.style.display = "inline";
    btnText.innerHTML = "Læs mere"; 
    moreText.style.display = "none";
  } else {
    dots.style.display = "none";
    btnText.innerHTML = "Læs mindre"; 
    moreText.style.display = "inline";
  }
}

if( $('#search_reveal').is(':visible') == false ){
    console.log('not vis');
    $('.mobile-seeks').on('click', function(){
        $('#search_reveal').css('display', 'block');
    });
}else if( $('#search_reveal').is(':visible') == true ){
    console.log('VIS');
    $('.mobile-seeks').on('click', function(){
        $('#search_reveal').css('display', 'none');
    });
}



// Get the base URL for translated product
var baseUrl = "https://shop-viclara.myshopify.com";

$('.swatch-element').on('click', function(){
    var prodId = $(this).attr('data-id');

   // getInventoryNumber();
    
});

/*function getInventoryNumber(){
  if( $('body').hasClass('template-product') ){
      console.log('body');
      setTimeout(() => {
          var queryString = window.location.search;
          var urlParams = new URLSearchParams(queryString);
          var prodID = urlParams.get('variant');
          var dataVendor = $('.product__section-content').attr('data-vendor');
          var singleProdId = returnProductId();
          var request = baseUrl+'/admin/api/2021-04/variants/'+prodID+'.json';
        
          if( returnVariantsVolume() == true ){
              
              fetch(request, {
                credentials: 'same-origin',
                method: 'GET',
                headers: {
                  'mode': 'no-cors',
                  'Access-Control-Allow-Origin': 'no-cors',
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
                }
              }).then(function(res){
                return res.json();
              }).then(function(j) {
                  // Yay, `j` is a JavaScript object
                  console.log(JSON.stringify(j));
              }).catch(function(error) {
                  console.log('Request failed', error)
              });

              // .done(function(data){
              //     var inventory = data.variant.inventory_quantity;
              //     var inventoryNum = parseInt(inventory);
      
              //     if( inventoryNum == 0 ){
              //         console.log('ikke på lager');
              //         if( dataVendor == "Mulberry"){
              //             $('.inventory-msg p').text("kontakt os for levering.");
              //         }else{
              //             $('.inventory-msg p').text('Ikke på lager, forventet levering mellem 4-10 dage.');
              //         }
              //     }else{
              //         $('.inventory-msg p').text('');
              //         console.log( JSON.parse(inventory) + ' Er på lager' );
              //     }
              // });
          }else if(returnVariantsVolume() == false ) {
            console.log('THIS DATA1');
              jQuery.ajax({
                  url: baseUrl+'/admin/api/2021-04/products/'+singleProdId+'.json',
                  crossDomain: true,
                  dataType: 'json'
              })
              .done(function(data){
                  console.log(data);
                  console.log('THIS DATA2');
                
                  var inventory = data.product.variants[0].inventory_quantity;
                  console.log(inventory)

                  var inventoryNum = parseInt(inventory);

                  if( inventoryNum == 0 ){
                      console.log('ikke på lager');
                      if( dataVendor == "Mulberry"){
                          $('.inventory-msg p').text("kontakt os for levering.");
                      }else{
                          $('.inventory-msg p').text('Ikke på lager, forventet levering mellem 4-10 dage.');
                      }
                  }else{
                      $('.inventory-msg p').text('');
                      console.log( JSON.parse(inventory) + ' Er på lager' );
                  }
              });
          }
          
      }, 100);
  }
}getInventoryNumber();*/

$(document).ready(function() {
  function updateInventoryMsg(value) {
    var dataQuantity = jQuery('input[value="' + value + '"]').parent().attr('data-quan');
    var parent = jQuery('input[value="' + value + '"]').parent();
    if (jQuery('input[value="' + value + '"]').attr('value') == value) {
      if (dataQuantity > 0) {
        jQuery('.inventory-msg.normal p').html('<span class="stock-dot"> </span><p class="status"><span class="stock-dot-text">På Lager: Levering 1-3 hverdage</span></p>');
      } else if (parent.hasClass("soldout")) {
        jQuery('.inventory-msg.normal p').html('<span class="sold-out-dot"> </span><p class="status"><span class="sold-out-dot-text"> Pre Order: Forventet Levering 3-9 hverdage.</span></p>');
      } else {
        jQuery('.inventory-msg.normal p').html('<span class="sold-out-dot"> </span><p class="status"><span class="sold-out-dot-text">  Pre Order: Forventet Levering 3-9 hverdage.</span></p>');
      }
      if (parent.hasClass("soldout")) {
        jQuery('.inventory-msg.normal p').html('<span class="sold-out-dot"> </span><p class="status"><span class="sold-out-dot-text"> Pre Order: Forventet Levering 3-9 hverdage.</span></p>');
      }
    }
  }

  jQuery('.single-option-selector').each(function() {
    var value = jQuery('option:selected', this).text();
    updateInventoryMsg(value);
  });

  jQuery('.single-option-selector').on('change', function() {
    var value = jQuery('option:selected', this).text();
    updateInventoryMsg(value);
  });
});



// Predictive search

var selectors = {
    colorSwatchImage: '.grid-product__color-image',
    colorSwatch: '.color-swatch--with-image',
    sortSelect: '#SortBy'
  };

  var data = {
    sortBy: 'data-default-sortby'
  };

  function Collection(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.namespace = '.collection-' + this.sectionId;

    this.init();
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    init: function() {
      // init is called on load and when tags are selected
      this.$container = $(this.container);
      var sectionId = this.sectionId = this.$container.attr('data-section-id');
      this.namespace = '.collection-' + sectionId;

      this.$sortSelect = $(selectors.sortSelect);
      this.$sortSelect.on('change', this.onSortChange.bind(this));
      this.defaultSort = this.getDefaultSortValue();

      this.initParams();
      this.colorSwatchHovering();

      theme.reinitSection('collection-sidebar');
    },

    initParams: function() {
      this.queryParams = {};

      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    getDefaultSortValue: function() {
      return this.$sortSelect.attr(data.sortBy);
    },

    onSortChange: function() {
      this.queryParams.sort_by = this.getSortValue();

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = $.param(this.queryParams);
    },

    colorSwatchHovering: function() {
      var $colorImage = $(selectors.colorSwatchImage);
      if (!$colorImage.length) {
        return;
      }

      $(selectors.colorSwatch).on({
        mouseenter: function (evt) {
          $el = $(evt.currentTarget);
          var id = $el.data('variant-id');
          var image = $el.data('variant-image');
          $('.grid-product__color-image--' + id)
            .css('background-image', 'url(' + image + ')')
            .addClass('is-active');
        },
        mouseleave: function (evt) {
          $el = $(evt.currentTarget);
          var id = $el.data('variant-id');
          $('.grid-product__color-image--' + id).removeClass('is-active');
        }
      });
    },

    forceReload: function() {
      this.onUnload();
      this.init();
    },

    onUnload: function() {
      $(window).off(this.namespace);
      this.$container.off(this.namespace);
      $(selectors.colorSwatch).off(this.namespace);
    }
  });
